import { render, staticRenderFns } from "./VisitorNotifications.vue?vue&type=template&id=d36e6f74&scoped=true"
import script from "./VisitorNotifications.vue?vue&type=script&lang=js"
export * from "./VisitorNotifications.vue?vue&type=script&lang=js"
import style0 from "./VisitorNotifications.vue?vue&type=style&index=0&id=d36e6f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36e6f74",
  null
  
)

export default component.exports